import { useEffect } from 'react';

import { showSuccess, showError } from '@/shared';

import type { TCustomError } from '@/shared';

type Params = {
  isSuccess?: boolean;
  successTitle?: string;
  successMessage?: string;
  isError?: boolean;
  errorTitle?: string;
  errorMassage?: string;
  error?: TCustomError;
};

export const useShowResponseStatus = (params: Params) => {
  const {
    isSuccess,
    successTitle = 'Успех!',
    successMessage = 'Операция выполнена успешно',
    isError,
    errorTitle = 'Ошибка!',
    errorMassage = 'Произошла ошибка!',
    error,
  } = params;

  useEffect(() => {
    if (isSuccess) {
      showSuccess({ title: successTitle, message: successMessage });
    }

    if (isError) {
      showError({ title: errorTitle, message: errorMassage });
    }

    const errorText = error?.message || error?.root;
    if (errorText) {
      showError({ title: errorTitle, message: errorText });
    }
  }, [isSuccess, isError, error?.root, error?.message]);
};
